'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowMove = function TiArrowMove(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.5 13.8c-0.6-0.6-1.7-0.6-2.3 0s-0.7 1.7 0 2.4l2.1 2.1h-7.6v-7.6l2.1 2.1c0.3 0.4 0.8 0.5 1.2 0.5s0.9-0.1 1.2-0.5c0.6-0.6 0.6-1.7 0-2.3l-6.2-6.2-6.2 6.2c-0.6 0.6-0.6 1.7 0 2.3s1.7 0.7 2.4 0l2.1-2.1v7.6h-7.6l2.1-2.1c0.7-0.7 0.7-1.7 0-2.4s-1.7-0.6-2.3 0l-6.2 6.2 6.2 6.2c0.3 0.3 0.7 0.5 1.2 0.5s0.8-0.2 1.1-0.5c0.7-0.7 0.7-1.7 0-2.4l-2.1-2.1h7.6v7.6l-2.1-2.1c-0.7-0.7-1.7-0.7-2.4 0s-0.6 1.7 0 2.3l6.2 6.2 6.2-6.2c0.6-0.6 0.6-1.7 0-2.3s-1.7-0.7-2.4 0l-2.1 2.1v-7.6h7.6l-2.1 2.1c-0.7 0.7-0.7 1.7 0 2.4 0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5l6.2-6.2-6.2-6.2z' })
        )
    );
};

exports.default = TiArrowMove;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-move.js
// module id = 3502
// module chunks = 0